import api from '@edu-fe/api'

const record = api.create('/course/record', { method: 'POST', formData: true })
// const interval = 6 // 计时间隔，单位: s
// let timer = null // 保存计时器对象
// let currentTime = 0 // 保存当前播放时间
// let isFinished = 0 // 保存是否播放结束 0: 否, 1: 是
//
// function setTimer ({ chapterId, wpsSid }) {
//   timer = setInterval(() => {
//     console.log(timer)
//     record({
//       chapterId,
//       seconds: currentTime,
//       isFinished,
//       learnSeconds: interval,
//       wpsSid
//     })
//   }, interval * 1000)
// }
//
// export function clearTimer () {
//   console.log(timer)
//   clearInterval(timer)
// }
//
// /**
//  * @param { Element } el 需要上报进度的html媒体元素
//  * @param { String } chapterId 上报的章节ID
//  * @param { String } wpsSid
//  */
// export function report  ({ el, chapterId, wpsSid }) {
//   if (!el || el.nodeType !== 1) return console.error('Invalid media element')
//   if (!chapterId) return console.error('Invalid chapterId')
//   if (!wpsSid) return console.error('Invalid wpsSid')
//
//   const setEvent = () => setTimer({ chapterId, wpsSid })
//
//   // 清除已绑定的事件
//   el.removeEventListener('pause', clearTimer)
//   el.removeEventListener('play', setEvent)
//
//   // 绑定事件
//   el.addEventListener('pause', clearTimer)
//   el.addEventListener('play', setEvent)
//   el.addEventListener('timeupdate', e => {
//     const el = e.target
//     currentTime = parseInt(el.currentTime)
//     isFinished = el.currentTime >= (el.duration * 0.9) ? 1 : 0
//   })
// }
let Timer = null


export function clearTimer () {
  clearInterval(Timer)
}

class Record {
  constructor () {
    this.interval = 6 // 计时间隔，单位: s
    this.timer = null // 保存计时器对象
    this.currentTime = 0 // 保存当前播放时间
    this.isFinished = 0 // 保存是否播放结束 0: 否, 1: 是
    this.chapterId = ''
  }
  setTimer ({ chapterId, wpsSid }) {
    Timer = setInterval(() => {
      record({
        chapterId: this.chapterId,
        seconds: this.currentTime,
        isFinished: this.isFinished,
        learnSeconds: this.interval,
        userId: wpsSid
      })
    }, this.interval * 1000)
  }
  changeChapter (chapterId) {
    this.chapterId = chapterId
  }
  report ({ el, chapterId, wpsSid }) {
    if (!el || el.nodeType !== 1) return console.error('Invalid media element')
    if (!chapterId) return console.error('Invalid chapterId')
    if (!wpsSid) return console.error('Invalid wpsSid')
    this.chapterId = chapterId
    const setEvent = () => this.setTimer({ wpsSid })

    // 清除已绑定的事件
    el.removeEventListener('pause', clearTimer)
    el.removeEventListener('play', setEvent)

    // 绑定事件
    el.addEventListener('pause', clearTimer)
    el.addEventListener('play', setEvent)
    el.addEventListener('timeupdate', e => {
      const el = e.target
      this.currentTime = parseInt(el.currentTime)
      this.isFinished = el.currentTime >= (el.duration * 0.9) ? 1 : 0
    })
  }
}


export default new Record()
